var classes = {
  "root": "m_43657ece",
  "itemTitle": "m_2ebe8099",
  "item": "m_436178ff",
  "itemBullet": "m_8affcee1",
  "itemBody": "m_540e8f41"
};
export { classes as default };